import { getRequest, postRequest } from '@/helpers/request';
import { Order } from '@/types/Order';
import { Article } from '@/types/Article';
import { Tag } from '@/types/Tag';
import { Group } from '@/types/Group';

type response = string

export default async function getArticleBottomStaticBlock(): Promise<response | null> {
  return getRequest<response>('/article_bottom_static_block');
}
